"use strict";

module.exports = function () {
  this.serverSearch();
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/refresh.js
// module id = 259
// module chunks = 0